export default __webpack_public_path__ + "static/media/time.3d67d0ad.svg";